import { render, staticRenderFns } from "./indexMobile.vue?vue&type=template&id=18ff4fcf&scoped=true"
import script from "./indexMobile.vue?vue&type=script&lang=js"
export * from "./indexMobile.vue?vue&type=script&lang=js"
import style0 from "./indexMobile.vue?vue&type=style&index=0&id=18ff4fcf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ff4fcf",
  null
  
)

export default component.exports